import { DecimalPipe } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UIIconComponent, UiNumberComponent } from '@design-system';
import { AccordionComponent } from '../../../../components/accordion/accordion.component';
import {
	PortfolioCompositionChartComponent,
	PortfolioCompositionChartSlice
} from '../portfolio-composition-chart/portfolio-composition-chart.component';
import { PortfolioCompositionItem } from './portfolio-composition.models';

@Component({
	selector: 'app-portfolio-composition',
	imports: [
		AccordionComponent,
		DecimalPipe,
		PortfolioCompositionChartComponent,
		RouterLink,
		UIIconComponent,
		UiNumberComponent
	],
	templateUrl: './portfolio-composition.component.html'
})
export class PortfolioCompositionComponent {
	composition = input.required<PortfolioCompositionItem[]>();
	amountsHidden = input.required<boolean>();
	maskedValue = input.required<string>();

	readonly compositionExpanded = signal(true);
	readonly otherExpanded = signal(false);

	readonly chartData = computed<PortfolioCompositionChartSlice[]>(() =>
		this.composition()
			.filter(item => item.value > 0)
			.map(item => ({
				name: item.label,
				value: item.value,
				color: item.color,
				percentage: item.percentage
			}))
	);

	readonly chartAriaLabel = computed(
		() =>
			'نمودار ترکیب دارایی: ' +
			this.composition()
				.map(item => item.label + ' ' + item.percentage.toFixed(0) + ' درصد')
				.join('، ')
	);
}
